import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import Image from "react-image-webp";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Metatag from "../../hooks/Metatag";
import globalVariables from "../../global-variables";
import CountUp from "react-countup";
import axios from "axios";
import { Button } from "reactstrap";

export default function SustainabilityLeadership() {
  const [show, setShow] = useState(false);
  const [impactMetricsList, setImpactMetricsList] = useState(null);

  useEffect(() => {
    let _obj = new Object();
    _obj.imp_met_status = 1;

    axios
      .post(
        globalVariables.variables.strApiUrl +
        "/impactMetricsApi/getImpactMetricsList",
        _obj,
      )
      .then((response) => {
        setImpactMetricsList(response.data[0]);
      });
  }, []);

  useEffect(() => {
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10
        ? $(".fixed-top").removeClass("bg-header-home")
        : $(".fixed-top").removeClass("bg-header-home");
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, [impactMetricsList]);

  return (
    <>
      <Header></Header>
      <Metatag
        title="Professional Certificate Programme in Sustainability Leadership and Practice"
        description="Professional Certificate Programme in Sustainability Leadership and Practice"
        keywords="Professional Certificate Programme in Sustainability Leadership and Practice"
      />

      {/* Event Visual Panel */}
      <Container fluid className="bg-visual-inside-eve-details px-0" >
        <div className="visual-inside-big h-100">
          <Container className="h-100">
            <Row className="g-md-0 h-100 rounded-4 justify-content-center align-items-center">
              <Col xs={8} md={6}>
                <h1 className="fw-light text-white d-inline-block m-0 align-self-center wow fadeInUp">
                  Professional Certificate Programme in Sustainability Leadership and Practice
                </h1>
              </Col>
              <Col xs={4} md={6}>
                <Button className="btn btn-primary rounded-pill Faicon px-3 py-1 ms-auto d-flex align-items-center wow fadeInUp">
                  Back
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      {/* Events Container */}

      {/* Container */}
      <Container className="my-md-5 mb-0 pt-4 pt-xl-5">
        <Row className="g-0">
          <Col md={10} lg={10}>
            <div className="border rounded-4 px-lg-5 p-4 py-lg-5 h-100">
              <div className="pe-md-2 col-md-11">
                <div className="mb-5">
                  <h3 className="mb-3 wow fadeInUp">Why Sustainability Leadership Matters Today</h3>
                  <p className="wow fadeInUp">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed efficitur egestas posuere. Aliquam tristique turpis eu nibh vestibulum, placerat maximus erat dapibus. Nam vulputate pharetra ex, vitae pretium dui pharetra sed. Ut lacus mauris, ornare ac nisi sed, elementum vehicula ipsum. Vivamus dignissim eu ex vitae cursus. Praesent laoreet non elit sagittis porta. Duis pulvinar suscipit enim ac congue. Morbi nisi diam, malesuada sed turpis quis, rhoncus fermentum nisl. Integer eget leo porta, molestie nibh porttitor, aliquam nulla. Sed vitae orci nec tellus condimentum mattis imperdiet in felis. Sed blandit sapien ornare, aliquam urna ut, dignissim massa. Aenean aliquam nunc nibh, viverra dictum nisi lobortis non.</p>
                  <p className="wow fadeInUp">Sustainability has emerged as a strategic imperative for businesses, governments, and financial institutions worldwide. Increasing regulatory requirements, ESG disclosure obligations, climate commitments, resource constraints, and stakeholder expectations are reshaping how organizations create value, manage risk, and remain competitive in a rapidly changing environment.</p>
                  <p className="wow fadeInUp">Sustainability considerations now influence investment decisions, supply chain strategies, innovation, operational efficiency, and long-term business performance. As organizations move from setting sustainability goals to delivering measurable outcomes, the demand for professionals who can integrate sustainability into strategy and operations continues to grow.</p>
                  <p className="wow fadeInUp">As sustainability transitions from a specialized function to an enterprise-wide priority, organizations increasingly require leaders who can navigate the intersection of business, technology, policy, and environmental stewardship. This evolving landscape calls for professionals who can translate sustainability ambitions into actionable strategies, drive organizational transformation, and create long-term value for both business and society.</p>
                </div>
                <div className="mb-5">
                  <h3 className="mb-3 wow fadeInUp">About The Programme</h3>
                  <p className="wow fadeInUp">Designed to equip professionals with the knowledge, tools, and perspectives required to address sustainability challenges and opportunities across sectors, this programme integrates sustainability science, engineering principles, business strategy, policy frameworks, and quantitative assessment tools into a structured, application-oriented learning experience.</p>
                  <p className="wow fadeInUp">It builds interdisciplinary competence for integrating sustainability into organizational strategy and operations. Participants gain practical understanding of key frameworks and their application in driving transformation and long-term value creation.</p>
                  <p className="wow fadeInUp">By combining academic rigour with industry relevance, the programme prepares professionals to lead sustainability initiatives and contribute to responsible, future-focused decision-making across organizations and industries.</p>
                </div>
                <div className="mb-5">
                  <h3 className="mb-3 wow fadeInUp">Programme Highlights</h3>
                  <ul className="d-lg-none d-block">
                    <li>IIT Bombay Certificate</li>
                    <li>Delivered by IIT Bombay Faculty</li>
                    <li>Interdisciplinary Curriculum</li>
                    <li>Campus Immersion Experience</li>
                    <li>Masterclasses by Industry Practitioners</li>
                    <li>Live Faculty Sessions</li>
                    <li>Real-World Application</li>
                    <li>Future-Ready Skills</li>
                    <li>Industrial Case Studies</li>
                  </ul>

                  <img src={global.variables.strDomainUrl + "images/pic-programme-highlights.jpg"} className="img-fluid rounded-3 wow fadeInUp" />
                </div>
                <div className="mb-5">
                  <h3 className="mb-3 wow fadeInUp">Key Learning Outcomes</h3>
                  <ul className="wow fadeInUp">
                    <li> Lead organizational sustainability strategies at the intersection of business, policy, technology, and society. </li>
                    <li> Build industry-relevant ESG expertise aligned with global and Indian regulatory frameworks. </li>
                    <li> Apply sustainability assessment tools and frameworks for evidence-based decision-making. </li>
                    <li> Integrate climate resilience and circular economy thinking into business strategy and operations. </li>
                    <li> Strengthen leadership readiness to drive and contribute to sustainability transitions across organizations and sectors. </li>
                  </ul>
                </div>

                <div className="mb-5">
                  <h3 className="mb-3 wow fadeInUp">Who Should Attend</h3>
                  <ul className="wow fadeInUp">
                    <li>ESG / Sustainability Analysts</li>
                    <li>CSR and Corporate Affairs Leads </li>
                    <li>Operations & Supply Chain Managers</li>
                    <li>Strategy and Finance Professionals</li>
                    <li>Policy and Government Officials</li>
                    <li>Sustainability Consultants</li>
                    <li>Entrepreneurs in Green Ventures </li>
                    <li>Senior Engineers in Energy & Manufacturing </li>
                    <li>Professionals transitioning to ESG roles</li>
                  </ul>
                </div>

                <div className="mb-5">
                  <h3 className="mb-3 wow fadeInUp">Programme Structure</h3>
                  <div className="row row-cols-lg-2">
                    <div className="col">
                      <div className="border h-100 p-3">
                        <h6 className="text-primary mb-1 wow fadeInUp">CORE · MANDATORY</h6>
                        <h4 className="text-dark mb-1 wow fadeInUp">Foundations of Sustainability and ESG Leadership</h4>
                        <p className="wow fadeInUp">SDGs, systems thinking, ESG frameworks (BRSR, GRI, ISSB, TCFD), decarbonization strategies, Scope 1–3 emissions, and corporate sustainability.</p>
                      </div>
                    </div>

                    <div className="col">
                      <div className="border h-100 p-3">
                        <h6 className="text-primary mb-1 wow fadeInUp">CORE · MANDATORY</h6>
                        <h4 className="text-dark mb-1 wow fadeInUp">Sustainability Assessment Tools and Decision Support</h4>
                        <p className="wow fadeInUp">Hands-on LCA using OpenLCA, GHG Protocol, carbon footprinting, MFA, water footprint, S-LCA, ISO standards, and AI for sustainability reporting.</p>
                      </div>
                    </div>

                    <div className="col">
                      <div className="border h-100 p-3">
                        <h6 className="text-secondary mb-1 wow fadeInUp">ELECTIVE · OPTIONAL</h6>
                        <h4 className="text-dark mb-1 wow fadeInUp">Circular Economy and Sustainable Systems Transformation</h4>
                        <p className="wow fadeInUp">Circular design, business models, EPR policy, India's circular economy landscape, industrial symbiosis, and technology pathways for circularity.</p>
                      </div>
                    </div>

                    <div className="col">
                      <div className="border border- h-100 p-3">
                        <h6 className="text-secondary mb-1 wow fadeInUp">ELECTIVE · OPTIONAL</h6>
                        <h4 className="text-dark mb-1 wow fadeInUp">Climate Risk, Policy and Net Zero Transitions</h4>
                        <p className="wow fadeInUp">Climate science, carbon budgets, net-zero pathways, carbon markets (Indian & EU ETS), CBAM, TCFD, physical and transition risk assessment.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-5">
                  <h3 className="mb-3 wow fadeInUp"> </h3>
                  <ul className="wow fadeInUp">
                    <li> </li>
                    <li> </li>
                    <li> </li>
                    <li> </li>
                  </ul>
                </div>

                <div className="mb-5">
                  <h3 className="mb-3 wow fadeInUp"> </h3>
                  <p className="wow fadeInUp"></p>
                  <p className="wow fadeInUp"></p>
                  <p className="wow fadeInUp"></p>
                </div>
              </div>
            </div>
          </Col>
          <Col md={3} lg={3} className="py-5 container-end" sticky="top">
            <div className="ps-lg-5 ps-md-4 bg-white">
              <div className="border-bottom border-4 border-primary rounded-4 h-100">
                <div className="bg-duration text-white rounded-4 py-4 px-4 border h-100">
                  <div className="mb-5">
                    <h5 className="fw-bold mb-4">Short Details</h5>
                    <Row className="row-cols-1 g-3 mb-5">
                      <Col>
                        <span className="d-block">Duration:</span>
                        1 year
                      </Col>
                      <Col>
                        <span className="d-block">Mode:</span>
                        Live Online + Campus Immersion
                      </Col>
                      <Col>
                        <span className="d-block">Weekly Commitment:</span>
                        ~3 hours / week
                      </Col>
                      <Col>
                        <span className="d-block">Eligibility:</span>
                        Graduation
                      </Col>
                      <Col>
                        <Link to="#" target="_blank" className="btn btn-secondary rounded-pill Faicon px-3 py-1 d-flex align-items-center wow fadeInUp">
                          Download Brochure
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>




      {/* Breadcrumb */}
      <Breadcrumb Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={global.variables.strDomainUrl}>
          Home
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Seminar on Micro Nano Plastics and their Environmental
          Impact</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}
